// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-input.zoom-slider,.v-input.zoom-slider .v-input__control,.v-input.zoom-slider .v-input__slot,.v-input.zoom-slider .v-slider{height:100%!important}.v-slider--vertical .v-slider__track-container{width:5px!important}.v-slider--horizontal .v-slider__track-container{height:5px!important}.v-slider__track-background{background-color:#b4b4b4!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
